import React, { useState, useEffect, useRef } from "react";
import Slider from 'react-slick';
import ImageWorkflow from "../../images/Flowchart.svg";
import ImageWorkflowMobile from "../../images/Flowchart-mobile.svg";

import ImageWebApp from "../../images/ecosystem-web-app.png";
import ImageMobile from "../../images/ecosystem-mobile.png";

import ImageWebAppElement1 from "../../images/web-app-element-1.png";
import ImageWebAppElement2 from "../../images/web-app-element-2.png";
import ImageMobileElement1 from "../../images/mobile-element-1.png";


import ImageDispatchManagement from "../../images/Dispatch-Management.jpg";
import ImageOrderShippingPlanning from "../../images/Order-Shipping-Planning.jpg";
import ImageRealTimeNotifications from "../../images/Real-time-Notifications.jpg";

import IconDelivery from "../../icons/icon-delivery-box.svg";
import IconNote from "../../icons/icon-note.svg";
import IconNotification from "../../icons/icon-notification.svg";

import IconDeliveryActive from "../../icons/icon-delivery-box-active.svg";
import IconNoteActive from "../../icons/icon-note-active.svg";
import IconNotificationActive from "../../icons/icon-notification-active.svg";


import IconFastDelivery from "../../icons/icon-fast-delivery.svg";
import IconEnterpriseSecurity from "../../icons/icon-pod-enterprise-security.svg";
import IconOmnichannel from "../../icons/icon-pod-omnichannel.svg";
import IconRealTimeVisibility from "../../icons/icon-real-time-visibility.svg";
import IconReschedulingSupport from "../../icons/icon-rescheduling-support.svg";
import { SlideInWithScroll } from '../common/utils/animations/slideInWithScroll';
import { motion } from 'framer-motion';
import $ from 'jquery';
import { directions } from '../common/utils/animations/animationConstants';
import Parallax from "../common/utils/animations/parallax";

export default function Technology() {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const ref = useRef();
  let slider1 = null;
  let slider2 = null;

  const setValues = () => {
      setNav1(slider1);
      setNav2(slider2);
      setElementTop($('.grid-layout-section').offset().top);
      setClientHeight(window.innerHeight);
  };

  useEffect(() => {
    //console.log('jq: ', $('.grid-layout-section').offset().top);
    if (!ref.current) return;
    setValues();
    window.addEventListener("resize", setValues);
    document.addEventListener("load", setValues);
    return () => {
      window.removeEventListener("resize", setValues);
      document.removeEventListener("load", setValues);
    };
  });

  const triggers = [[1, 0.8], [0.9, 0.7], [0.8, 0.6], [1, 0.8], [0.9, 0.7], [0.8, 0.6],];
  const settings = {
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  const gridItems = [
    {
      icon: <IconFastDelivery />,
      title: "Multiple Shipping Methods",
      content: "Automatically optimizes the delivery costs, time, and customer experiences with built-in integrations with third-party shipping partners such as FedEx and USPS."
    }, {
      icon: <IconReschedulingSupport />,
      title: "Rescheduling Support",
      content: "Enable customers to reschedule their deliveries and quickly reschedule the deliveries to address delays and unexpected events in real-time."
    }, {
      icon: <IconEnterpriseSecurity />,
      title: "Enterprise Security",
      content: "Secured with role-based access controls, encryption, audit trails, single-sign-on, and many more enterprise security standards to enable safe and secure operations."
    }, {
      icon: <IconOmnichannel />,
      title: "Omnichannel",
      content: "The platform offers a seamless experience for every stakeholder - managers, warehouse staff, drivers, and customers with mobile and web apps."
    }, {
      icon: <IconRealTimeVisibility />,
      title: "Real-time Visibility",
      content: "Know where each truck and shipments are in real-time using GPS IoT devices and maps to precisely predict the delivery times and monitor all operations."
    },
  ];

  return (
    <div className="section-gap pod-ecosystem-section">
      <div className="ecosystem-reshaping">
        <div className="container section-gap-large">
          <div className="ecosystem-content section-gap-small">
            <h3 className="h3">Reshaping the future of last-mile ecosystem</h3>
            <p>Together with the client, we performed a detailed baseline assessment of their current operations. We interviewed their delivery managers to identify the key challenges, overheads, bottlenecks, and customer expectations. After thorough research, our team mapped out both current and next-gen processes and prepared a transformation roadmap for the most advanced and paperless last-mile delivery platform, which automated manual work, boosted margins, and improved delivery experience.</p>
            <div className="workflow-img">
              <div className="section-gap workflow-img-inner">
                <img src={ImageWorkflow} className="hide-from-mobile" title="last-mile ecosystem" alt="last-mile ecosystem" />
                <img src={ImageWorkflowMobile} className="d-none show-from-mobile" title="last-mile ecosystem" alt="last-mile ecosystem" />
              </div>
              <p>Next, our product team designed, developed, and delivered an end-to-end platform in just 90 days. </p>
            </div>

          </div>
          <div className="ecosystem-image">
            <div className="process-img">
              <div className="hide-from-mobile">
                <Parallax classes="web-app" id="web-app" direction={directions.BTT} length={100} triggers={[1, 0.6]}>
                  <img src={ImageWebApp} title="last mile delivery solution" alt="last mile delivery solution" />
                  <small>DELIVERY MANAGER & CONTROL TOWER</small>

                  <div className="web-app-element">
                    <img src={ImageWebAppElement1} title="last mile delivery solution" alt="last mile delivery solution" />
                    <img src={ImageWebAppElement2} title="last mile delivery solution" alt="last mile delivery solution" />
                  </div>
                </Parallax>
                <Parallax classes="mobile-app" id="mobile-app" direction={directions.BTT} length={100} triggers={[1, 0.6]}>
                  <img src={ImageMobile} title="last mile delivery solution" alt="last mile delivery solution" />
                  <small>DELIVERY APP</small>
                  <div className="mobile-element">
                    <img src={ImageMobileElement1} title="last mile delivery solution" alt="last mile delivery solution" />
                  </div>
                </Parallax>
              </div>
              <div className="show-from-mobile">
                <Slider
                  infinite={true}
                  arrows={false}
                  autoplay={true}
                  autoplaySpeed={5000}
                  fade={true}
                  speed={1000}
                >
                  <div className="web-app">
                    <img src={ImageWebApp} title="last mile delivery solution" alt="last mile delivery solution" />
                    <small>DELIVERY MANAGER & CONTROL TOWER</small>

                    <div className="web-app-element">
                      <img src={ImageWebAppElement1} title="last mile delivery solution" alt="last mile delivery solution" />
                      <img src={ImageWebAppElement2} title="last mile delivery solution" alt="last mile delivery solution" />
                    </div>
                  </div>
                  <div className="mobile-app">
                    <img src={ImageMobile} title="last mile delivery solution" alt="last mile delivery solution" />
                    <small>DELIVERY APP</small>
                    <div className="mobile-element">
                      <img src={ImageMobileElement1} title="last mile delivery solution" alt="last mile delivery solution" />
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>

        <div className="pod-ecosystem-delivery-platform section-gap">
          <div className="container">
            <div className="pod-ecosystem-delivery-platform-desc">
              <h2 className="h3">The automated last-mile delivery platform  </h2>
              <p>The new platform automated shipment planning, dispatching, fleet assignment, route management, real-time monitoring across all locations, and much more. The following suite of features enabled delivery staff to provide an excellent customer experience and gain operational efficiency:</p>
            </div>
            <div className="pod-ecosystem-delivery-platform-image">
              <Slider
                asNavFor={nav2}
                ref={slider => (slider1 = slider)}
                //infinite={true}
                arrows={false}
                slidesToShow={1}
                swipeToSlide={true}
                fade={true}>
                <img src={ImageOrderShippingPlanning} title="delivery platform" alt="delivery platform" />
                <img src={ImageDispatchManagement} title="delivery platform" alt="delivery platform" />
                <img src={ImageRealTimeNotifications} title="delivery platform" alt="delivery platform" />
              </Slider>
            </div>

            <div className="tab-grid">
              <Slider
                asNavFor={nav1}
                ref={slider => (slider2 = slider)}
                arrows={false}
                infinite={true}
                slidesToShow={3}
                slidesToScroll={1}
                autoplay={true}
                speed={1000}
                autoplaySpeed={5000}
                focusOnSelect={true}
                focusOnHover={false}
                pauseOnHover={true}
                {...settings}>
                <div className="two-column-item">
                  <div className="item-inner">
                    <div className="item-icon">
                      <i><IconNote /><IconNoteActive /></i>
                    </div>
                    <div className="item-content">
                      <h3 className="h5">Order & Shipment Planning</h3>
                      <p>Plan and prepare shipments for all customer orders based on accurate location, products, shipping SLAs, and available fleet.</p>
                    </div>
                  </div>
                </div>
                <div className="two-column-item">
                  <div className="item-inner">
                    <div className="item-icon">
                      <i><IconDelivery /><IconDeliveryActive /></i>
                    </div>
                    <div className="item-content">
                      <h3 className="h5">Dispatch Management</h3>
                      <p>Pick the right shipping channels and vehicles, and enable warehouse teams to verify, load, and dispatch the shipments with automated features.</p>
                    </div>
                  </div>
                </div>
                <div className="two-column-item">
                  <div className="item-inner">
                    <div className="item-icon">
                      <i><IconNotification /><IconNotificationActive /></i>
                    </div>
                    <div className="item-content">
                      <h3 className="h5">Real-time Notifications</h3>
                      <p>Real-time notifications for each shipment - at each step from order to delivery - enables managers to ensure that nothing  falls through the cracks.</p>
                    </div>
                  </div>
                </div>
              </Slider>
              <div ref={ref} className="grid-layout-section">
                <div className="row d-flex flex-wrap">
                  {
                    gridItems.map((item, i) => {
                      return <Parallax classes="col grid-item" id={"col-grid-item" + i} key={i} triggers={triggers[i]} length={50} direction={directions.BTT} opacity={true} >
                        <div className="item-inner">
                          <div className="grid-icon-left">
                            <i className="icon-small">{item.icon}</i>
                          </div>
                          <h3>{item.title}</h3>
                          <p>{item.content}</p>
                        </div>
                      </Parallax>;
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

